var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('Header'),_c('MainHome'),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }